import React from 'react';
import FooterLinkComponent from './FooterLinkComponent';
import { useReactiveVar } from '@apollo/client';
import { userInfo } from '@apollo-internal/cache';

const Footer = () => {
  const currentUserInfo = useReactiveVar(userInfo);

  return (
    <footer>
      <menu id='footerContainer' className='footerContainer' aria-label='Support'>
        <div>&copy; {new Date().getFullYear()} ISACA. All Rights Reserved.</div>
        <div id='links' className='links'>
          {currentUserInfo && !currentUserInfo.IsDeactivated && (
            <FooterLinkComponent
              href='mailto:vip@isaca.org'
              id='Support'
              linkText='Support'
              isNewTab={true}
            />
          )}
          <FooterLinkComponent
            href='https://www.isaca.org/privacy-policy'
            id='Privacy'
            linkText='Privacy'
            isNewTab={true}
          />
          <FooterLinkComponent
            href='https://www.isaca.org/ad-and-cookie-policy'
            id='Cookie Policy'
            linkText='Cookie Policy'
            isNewTab={true}
          />
          <FooterLinkComponent
            href='https://www.isaca.org/terms-of-use'
            id='Terms of Use'
            linkText='Terms of Use'
            isNewTab={true}
          />
        </div>
      </menu>
    </footer>
  );
};

export default Footer;
